import { Component, effect, Input, signal } from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";

@Component({
    selector: "app-share-list",
    imports: [SharedMaterialModule, SharedDsnModule],
    templateUrl: "./share-list.component.html",
    styleUrl: "./share-list.component.scss",
})
export class ShareListComponent {
    @Input() ships: string[] = [];

    constructor() {}
}
